<div class="pcoded" [attr.nav-type]="navType" [attr.theme-layout]="themeLayout" [attr.layout-type]="layoutType"
  [attr.vertical-placement]="verticalPlacement" [attr.vertical-layout]="verticalLayout"
  [attr.pcoded-device-type]="deviceType" [attr.vertical-nav-type]="verticalNavType"
  [attr.vertical-effect]="verticalEffect" [attr.vnavigation-view]="vNavigationView" (window:resize)="onResize($event)">
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav class="navbar header-navbar pcoded-header" [attr.pcoded-header-position]="pcodedHeaderPosition"
      [attr.header-theme]="headerTheme">
      <div class="navbar-wrapper">
        <div class="navbar-logo" [attr.logo-theme]="logoTheme" [style.background]="empresaColorPrimario">
          <a class="mobile-menu" id="mobile-collapse" href="javascript:;" (click)="toggleOpened()"
            [exclude]="'#main_navbar'" (clickOutside)="onClickedOutside($event)">
            <i class="ti-menu"></i>
          </a>
          <a [routerLink]="['/']">
            <img class="img-fluid" [src]="empresaLogo" alt="Theme-Logo" style="width: 115px; max-height: 46px; object-fit: contain;" />
          </a>
          <a (click)="onMobileMenu()" class="mobile-options">
            <i class="ti-more"></i>
          </a>
        </div>

        <div class="navbar-container">
          <div>
            <ul class="nav-left">
              <li>
                <div class="sidebar_toggle"><a href="javascript:;" (click)="toggleOpened()"><i
                class="ti-menu f-18"></i></a></div>
              </li>
              <li>
                <a href="javascript:;" appToggleFullScreen>
                  <i class="ti-fullscreen"></i>
                </a>
              </li>              <li class="theme-toggle-item">
                <a class="pointer theme-toggle" href="javascript:;" (click)="ToggleModoOscuro()" [attr.title]="modoOscuro ? 'Modo claro' : 'Modo oscuro'">
                  <i [class]="modoOscuro ? 'ti-shine' : 'ti-moon'"></i>
                </a>
              </li>
            </ul>
            <ul [@mobileMenuTop]="isCollapsedMobile" class="nav-right" [ngClass]="isCollapsedMobile">
              <li class="header-notification">
                <a href="javascript:;">
                  <i class="ti-bell"></i>
                  @if (lNotificaciones.length > 0) {
                    <span class="badge bg-c-pink"></span>
                  }
                </a>
                <ul class="show-notification">
                  <li>
                    <h6>Notificaciones</h6>
                  </li>
                  <li class="lNotificaciones">
                    @if (lNotificaciones.length == 0) {
                      <div class="media">
                        <div class="media-body">
                          <p class="notification-msg">No hay notificaciones</p>
                        </div>
                      </div>
                    }
                    @for (notificacion of lNotificaciones; track notificacion; let i = $index) {
                      <div class="media">
                        <div class="media-body">
                          @if (notificacion.tipoNotificacion == 1) {
                            <h5 class="notification-user bg-success">Exitoso</h5>
                          }
                          @if (notificacion.tipoNotificacion == 2) {
                            <h5 class="notification-user bg-warning">Advertencia
                            </h5>
                          }
                          @if (notificacion.tipoNotificacion == 3) {
                            <h5 class="notification-user bg-danger">Error</h5>
                          }
                          @if (notificacion.tipoNotificacion == 4) {
                            <h5 class="notification-user bg-info">Información
                            </h5>
                          }
                          <p class="notification-msg">{{notificacion.notificacion}}</p>
                          <span class="notification-time">{{notificacion.fechaRegistro | date:'dd MMM yyyy hh:mm a'
                          }}</span>
                        </div>
                        <a type="button" class="close" aria-label="Close" (click)="Elimina(notificacion)">
                          <span aria-hidden="true">&times;</span>
                        </a>
                      </div>
                    }
                  </li>
                </ul>
              </li>
              <li class="header-notification">
                <a class="pointer" (click)="logOut()">
                  <i class="ti-layout-sidebar-left"></i> Cerrar Sesion
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div [@slideOnOff]="verticalPlacement === 'right' ? chatInnerToggleInverse : chatInnerToggle"
      class="card card_main showChat_inner">
      <div class="media chat-inner-header">
        <a class="back_chatBox" (click)="toggleChatInner()">
          <i class="icofont icofont-rounded-left"></i> Josephin Doe
        </a>
      </div>
      <perfect-scrollbar [style.max-width]="'100%'" [style.max-height]="'calc(100vh - 230px)'" [config]="config">
        <div class="media chat-messages">
          <a class="media-left photo-table" href="javascript:;">
            <img class="media-object  m-t-5" src="assets/images/avatar-1.jpg" alt="Generic placeholder image">
          </a>
          <div class="media-body chat-menu-content">
            <div class="">
              <p class="chat-cont">I'm just looking around. Will you tell me something about yourself?</p>
              <p class="chat-time">8:20 a.m.</p>
            </div>
          </div>
        </div>
        <div class="media chat-messages">
          <div class="media-body chat-menu-reply">
            <div class="">
              <p class="chat-cont">I'm just looking around. Will you tell me something about yourself?</p>
              <p class="chat-time">8:20 a.m.</p>
            </div>
          </div>
          <div class="media-right photo-table">
            <a href="javascript:;">
              <img class="media-object  m-t-5" src="assets/images/avatar-4.jpg" alt="Generic placeholder image">
            </a>
          </div>
        </div>
      </perfect-scrollbar>
      <div class="chat-reply-box p-b-20">
        <div class="right-icon-control">
          <input type="text" class="form-control search-text" placeholder="Share Your Thoughts">
          <div class="form-icon">
            <i class="icofont icofont-paper-plane"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- right-bar inner chat end -->

    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        <nav id="main_navbar" class=" pcoded-navbar" (clickOutside)="onClickedOutside($event)"
          [exclude]="'#mobile-collapse'" [attr.pcoded-header-position]="pcodedHeaderPosition"
          [attr.navbar-theme]="navBarTheme" [attr.active-item-theme]="activeItemTheme" sub-item-theme="theme2"
          active-item-style="style0" [attr.pcoded-navbar-position]="pcodedSidebarPosition">
          <div class="sidebar_toggle"><a href="javascript:;"><i class="icon-close icons"></i></a></div>
          <div class="pcoded-inner-navbar main-menu" appAccordion>
            <div class="">
              <div class="main-menu-header">
                <img class="img-40 img-radius" src={{identity.foto}} alt="User-Profile-Image">
                <div class="user-details">
                  <span>{{identity.nombre}}</span>
                  <span id="more-details" [routerLink]="['/perfil']"><i
                  class="ti-user"></i>&nbsp;&nbsp;{{identity.perfil.nombre}}</span>
                </div>
              </div>
            </div>
            <hr class="m-0">
            <perfect-scrollbar [style.max-width]="'100%'" [style.max-height]="'calc(100vh - 230px)'" [config]="config">
              @for (asideItems of menuItems.getAll(); track asideItems) {
                <div class="d-color">
                  <div class="pcoded-navigatio-lavel" [attr.menu-title-theme]="menuTitleTheme">{{asideItems.label}}</div>
                  @for (asideItem of asideItems.main; track asideItem) {
                    <ul class="pcoded-item pcoded-left-item" [attr.item-border]="itemBorder"
                      [attr.item-border-style]="itemBorderStyle" [attr.subitem-border]="subItemBorder"
                      appAccordionLink group="{{asideItem.state}}">
                      @if (asideItem.type === 'external') {
                        <li [routerLinkActive]="['active']" appAccordionLink
                          group="{{asideItem.state}}">
                          <a href="" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                            <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label
                          }}</b></span>
                          <span class="pcoded-mtext">{{ asideItem.name }}</span>
                          @for (asideBadge of asideItem.badge; track asideBadge) {
                            <span
                            class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                          }
                          <span class="pcoded-mcaret"></span>
                        </a>
                      </li>
                    }
                    @if (asideItem.type === 'link') {
                      <li [routerLinkActive]="['active']" appAccordionLink
                        group="{{asideItem.state}}">
                        @if (asideItem.main_state) {
                          <a [routerLink]="['/', asideItem.main_state, asideItem.state]"
                            target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle
                            >
                            <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label
                          }}</b></span>
                          <span class="pcoded-mtext">{{ asideItem.name }}</span>
                          @for (asideBadge of asideItem.badge; track asideBadge) {
                            <span
                            class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                          }
                          <span class="pcoded-mcaret"></span>
                        </a>
                      } @else {
                        <a [routerLink]="['/', asideItem.state]" target="{{asideItem.target ? '_blank' : '_self'}}"
                          appAccordionToggle>
                          <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label
                        }}</b></span>
                        <span class="pcoded-mtext">{{ asideItem.name }}</span>
                        @for (asideBadge of asideItem.badge; track asideBadge) {
                          <span
                          class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                        }
                        <span class="pcoded-mcaret"></span>
                      </a>
                    }
                  </li>
                }
                @if (asideItem.type === 'sub') {
                  <li [routerLinkActive]="['active']" class="pcoded-hasmenu"
                    [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" appAccordionLink
                    group="{{asideItem.state}}">
                    <a [routerLinkActive]="['active']" href="javascript:;" appAccordionToggle>
                      <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label
                    }}</b></span>
                    <span class="pcoded-mtext">{{ asideItem.name }}</span>
                    @for (asideBadge of asideItem.badge; track asideBadge) {
                      <span
                      class="pcoded-badge label label-{{ asideBadge.type }}">{{asideBadge.value}}</span>
                    }
                    <span class="pcoded-mcaret"></span>
                  </a>
                  <ul class="pcoded-submenu">
                    @for (asideChildren of asideItem.children; track asideChildren) {
                      @if (asideChildren.type !== 'sub') {
                        <li [routerLinkActive]="['active']">
                          <a [routerLink]="['/', asideItem.state, asideChildren.state]"
                            target="{{asideChildren.target ? '_blank' : '_self'}}">
                            <span class="pcoded-micon"><i class="ti-angle-right"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name }} </span>
                            @for (asideChildrenBadge of asideChildren.badge; track asideChildrenBadge) {
                              <span
                              class="pcoded-badge label label-{{ asideChildrenBadge.type }}">{{asideChildrenBadge.value}}</span>
                            }
                            <span class="pcoded-mcaret"></span>
                          </a>
                        </li>
                      }
                      @if (asideChildren.type === 'sub') {
                        <li [routerLinkActive]="['active']" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon"
                          [attr.subitem-icon]="subItemIcon" appAccordionLink
                          group="sub-toggled">
                          <a href="javascript:;" appAccordionToggle>
                            <span class="pcoded-micon"><i class="ti-direction-alt"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name }}</span>
                            @for (asideChildrenBadge of asideChildren.badge; track asideChildrenBadge) {
                              <span
                              class="pcoded-badge label label-{{ asideChildrenBadge.type }}">{{asideChildrenBadge.value}}</span>
                            }
                            <span class="pcoded-mcaret"></span>
                          </a>
                          <ul class="pcoded-submenu">
                            @for (asideChildrenSub of asideChildren.children; track asideChildrenSub) {
                              <li [routerLinkActive]="['active']">
                                <a [routerLink]="['/', asideItem.state, asideChildren.state, asideChildrenSub.state]"
                                  target="{{asideChildrenSub.target ? '_blank' : '_self'}}">
                                  <span class="pcoded-micon"><i class="ti-angle-right"></i></span>
                                  <span class="pcoded-mtext">{{ asideChildrenSub.name }}</span>
                                  @for (asideChildrenSubBadge of asideChildrenSub.badge; track asideChildrenSubBadge) {
                                    <span
                                    class="pcoded-badge label label-{{ asideChildrenSubBadge.type }}">{{asideChildrenSubBadge.value}}</span>
                                  }
                                  <span class="pcoded-mcaret"></span>
                                </a>
                              </li>
                            }
                          </ul>
                        </li>
                      }
                    }
                  </ul>
                </li>
              }
            </ul>
          }
        </div>
      }
    </perfect-scrollbar>
  </div>
</nav>
<div class="pcoded-content">
  <div class="pcoded-inner-content">
    <div class="main-body">
      <div class="page-wrapper">
        <app-title></app-title>
        <app-breadcrumbs></app-breadcrumbs>
        <div class="page-body">
          <router-outlet>
            <app-spinner></app-spinner>
          </router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
</div>



